import state$1 from './state.js';

const subscribers = {};
const onUpdateInNextStore = (func) => {
    subscribers["UpdateNextStore" /* UpdateNextStore */] = func;
};
const dispatchUpdateInNextStore = (data) => {
    return subscribers["UpdateNextStore" /* UpdateNextStore */](data);
};
/**
 * Add a callback to be called every time the store changes
 */
const afterChange = (cb) => {
    state$1.manualListeners.push(cb);
};

export { afterChange, dispatchUpdateInNextStore, onUpdateInNextStore };
